export const MSAL_SCOPES = ['09d9bc85-85ec-4260-bca0-ccd37aae465a/.default'];
